import styled from "styled-components";
import { useVotacao } from "../../contexts/VotacaoContext";
import SelectUser from "./SelectUser";
import VoteCandidato from "./VoteCandidato";

const Container = styled.div`
    width: 650px;
    max-width: 100%;
    max-height: 100%;
    background-color: white;
    border-radius: 30px;
    margin: auto;
    box-sizing: border-box;
    padding: 30px;
`

const ContainerVotacao = () => {

    const { validUser } = useVotacao();

    return (
        <>
            <Container>
                { validUser ? <VoteCandidato /> : <SelectUser /> }
            </Container>
        </>
    )
}

export default ContainerVotacao;